import { PlusCircleOutlined } from '@ant-design/icons';
import { useMutation } from '@apollo/client/react';
import { App, Modal } from 'antd';
import { useForm } from 'antd/es/form/Form';
import type React from 'react';
import { TestTubeColor, type TestTubeCreateInput, TestTubeSupplier } from '../../../../graphql/generated/graphql.ts';
import { CREATE_TEST_TUBE_MUTATION } from './CreateTestTubeModal.gql';
import { TestTubeForm } from './TestTubeForm';

export const CreateTestTubeModal: React.FC<{
  labId: string;
  modalVisible: boolean;
  onClose: () => void;
  onSuccess: () => void;
}> = ({ labId, modalVisible, onClose, onSuccess }) => {
  const [createTestTubeMutation, { loading }] = useMutation(CREATE_TEST_TUBE_MUTATION);
  const [form] = useForm<TestTubeCreateInput>();
  const { message } = App.useApp();

  const create = async (values: TestTubeCreateInput) => {
    try {
      await createTestTubeMutation({
        variables: {
          input: {
            ...values,
            labId: labId,
          },
        },
      });

      message.success('Probenbehälter wurde erstellt');
      onSuccess();
      closeAndReset();
    } catch (_e) {
      message.error('Probenbehälter konnte nicht erstellt werden');
    }
  };

  const closeAndReset = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      width={768}
      title="Neuen Probenbehälter erstellen"
      okText="Erstellen"
      okButtonProps={{ icon: <PlusCircleOutlined /> }}
      open={modalVisible}
      onCancel={closeAndReset}
      onOk={form.submit}
      confirmLoading={loading}
      destroyOnHidden
    >
      <TestTubeForm
        form={form}
        initialValues={{
          labId: labId,
          name: '',
          color: TestTubeColor.NONE,
          supplier: TestTubeSupplier.VACUETTE,
          labelText: '',
          labelText2: '',
          link: '',
          volume: 0,
          specialPrinterRequired: false,
        }}
        onFinish={values => create(values as TestTubeCreateInput)}
      />
    </Modal>
  );
};
